"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStageCounts = exports.getUseCaseCountByStage = exports.mapUseCasesWithStage = exports.sortUseCasesByName = exports.AI_HUB_SUBMISSION_URL_TEST = exports.AI_HUB_SUBMISSION_URL = void 0;
var ai_use_case_1 = require("../../shared/types/ai-use-case");
/**
 * External submission form for new AI Hub use cases.
 */
exports.AI_HUB_SUBMISSION_URL = 'https://avanade.sharepoint.com/sites/NTCHub/SitePages/AI-Hub-Idea-Submission.aspx?web=1';
exports.AI_HUB_SUBMISSION_URL_TEST = 'https://acp201890.sharepoint.com/sites/aihub/Lists/AI%20Hub%20%20Submitted%20Idea%20List/AllItems.aspx';
/**
 * Sorts use cases alphabetically by title.
 */
exports.sortUseCasesByName = function (useCases) {
    return useCases
        .map(function (useCase) { return ai_use_case_1.normalizeAiUseCase(useCase); })
        .sort(function (leftUseCase, rightUseCase) {
        var leftTitle = leftUseCase.title.toLowerCase();
        var rightTitle = rightUseCase.title.toLowerCase();
        if (leftTitle > rightTitle) {
            return 1;
        }
        if (leftTitle < rightTitle) {
            return -1;
        }
        return 0;
    });
};
/**
 * Applies the derived workflow stage to each use case.
 */
exports.mapUseCasesWithStage = function (useCases) {
    return useCases.map(function (useCase) {
        var normalizedUseCase = ai_use_case_1.normalizeAiUseCase(useCase);
        return __assign(__assign({}, normalizedUseCase), { fields: __assign(__assign({}, normalizedUseCase.fields), { stage: ai_use_case_1.getUseCaseStage(normalizedUseCase.id) }) });
    });
};
/**
 * Counts use cases in the requested stage.
 */
exports.getUseCaseCountByStage = function (useCases, stage) {
    return useCases.filter(function (useCase) { return useCase.fields.stage === stage; }).length;
};
/**
 * Builds the aggregated counts used by dashboard visualizations.
 */
exports.getStageCounts = function (useCases) {
    return useCases.reduce(function (stageCounts, useCase) {
        var stage = Number(useCase.fields.stage) || 1;
        if (stage === 1) {
            stageCounts.stage1 += 1;
        }
        else if (stage === 2) {
            stageCounts.stage2 += 1;
        }
        else if (stage === 3) {
            stageCounts.stage3 += 1;
        }
        else if (stage === 4) {
            stageCounts.stage4 += 1;
        }
        else if (stage === 5) {
            stageCounts.stage5 += 1;
        }
        else if (stage === 6) {
            stageCounts.stage6 += 1;
        }
        else if (stage === 7) {
            stageCounts.stage7 += 1;
        }
        return stageCounts;
    }, {
        stage1: 0,
        stage2: 0,
        stage3: 0,
        stage4: 0,
        stage5: 0,
        stage6: 0,
        stage7: 0,
    });
};
